"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dynamicTableSchemaValidator = exports.groupByColumnSchema = exports.summarizationSchema = exports.sharedSummarizedSchema = exports.selectedColumnSchema = exports.generalSummarizationSchema = exports.DynamicTableSummarizationType = void 0;
const zod_1 = require("zod");
const common_1 = require("./common");
const table_1 = require("./table");
var DynamicTableSummarizationType;
(function (DynamicTableSummarizationType) {
    DynamicTableSummarizationType["AVG"] = "AVG";
    DynamicTableSummarizationType["SUM"] = "SUM";
    DynamicTableSummarizationType["COUNT"] = "COUNT";
    DynamicTableSummarizationType["MAX"] = "MAX";
    DynamicTableSummarizationType["MIN"] = "MIN";
    DynamicTableSummarizationType["COUNT_DISTINCT"] = "COUNT_DISTINCT";
    DynamicTableSummarizationType["WEIGHTED_AVG"] = "WEIGHTED_AVG";
})(DynamicTableSummarizationType = exports.DynamicTableSummarizationType || (exports.DynamicTableSummarizationType = {}));
exports.generalSummarizationSchema = zod_1.z.discriminatedUnion('aggregation_type', [
    zod_1.z.object({
        aggregation_type: zod_1.z.literal(DynamicTableSummarizationType.AVG),
    }),
    zod_1.z.object({
        aggregation_type: zod_1.z.literal(DynamicTableSummarizationType.SUM),
    }),
    zod_1.z.object({
        aggregation_type: zod_1.z.literal(DynamicTableSummarizationType.COUNT),
    }),
    zod_1.z.object({
        aggregation_type: zod_1.z.literal(DynamicTableSummarizationType.MAX),
    }),
    zod_1.z.object({
        aggregation_type: zod_1.z.literal(DynamicTableSummarizationType.MIN),
    }),
    zod_1.z.object({
        aggregation_type: zod_1.z.literal(DynamicTableSummarizationType.COUNT_DISTINCT),
    }),
    zod_1.z.object({
        aggregation_type: zod_1.z.literal(DynamicTableSummarizationType.WEIGHTED_AVG),
        weighted_by_col: zod_1.z.string(),
    }),
]);
exports.selectedColumnSchema = zod_1.z.object({
    id: zod_1.z.string(),
    column_id: zod_1.z.string(),
    alias: zod_1.z.string(),
    general_summarizations: exports.generalSummarizationSchema.optional(),
});
exports.sharedSummarizedSchema = zod_1.z.object({
    summarization_id: zod_1.z.string().optional(),
    selected_column_id: zod_1.z.string().optional(),
    selected_summarization_id: zod_1.z.string().optional(),
});
exports.summarizationSchema = zod_1.z.discriminatedUnion('aggregation_type', [
    zod_1.z
        .object({
        aggregation_type: zod_1.z.literal(DynamicTableSummarizationType.AVG),
    })
        .merge(exports.sharedSummarizedSchema),
    zod_1.z
        .object({
        aggregation_type: zod_1.z.literal(DynamicTableSummarizationType.SUM),
    })
        .merge(exports.sharedSummarizedSchema),
    zod_1.z
        .object({
        aggregation_type: zod_1.z.literal(DynamicTableSummarizationType.COUNT),
    })
        .merge(exports.sharedSummarizedSchema),
    zod_1.z
        .object({
        aggregation_type: zod_1.z.literal(DynamicTableSummarizationType.MAX),
    })
        .merge(exports.sharedSummarizedSchema),
    zod_1.z
        .object({
        aggregation_type: zod_1.z.literal(DynamicTableSummarizationType.MIN),
    })
        .merge(exports.sharedSummarizedSchema),
    zod_1.z
        .object({
        aggregation_type: zod_1.z.literal(DynamicTableSummarizationType.COUNT_DISTINCT),
    })
        .merge(exports.sharedSummarizedSchema),
    zod_1.z
        .object({
        aggregation_type: zod_1.z.literal(DynamicTableSummarizationType.WEIGHTED_AVG),
        weighted_by_col: zod_1.z.string(),
    })
        .merge(exports.sharedSummarizedSchema),
]);
exports.groupByColumnSchema = zod_1.z.object({
    selected_column_id: zod_1.z.string(),
    summarizations: zod_1.z.array(exports.summarizationSchema),
});
const dynamicSchema = zod_1.z.object({
    selected_columns: zod_1.z.array(exports.selectedColumnSchema),
    group_by: zod_1.z.array(exports.groupByColumnSchema),
    filter: common_1.widgetFilterValidator.optional(),
    defaultOrder: table_1.rowOrderValidator.optional(),
});
exports.dynamicTableSchemaValidator = zod_1.z.intersection(common_1.commonTypeSchemaValidator, dynamicSchema);
